export const UTM_PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];

export type UtmParams = {
  [key in 'utm_source' | 'utm_medium' | 'utm_campaign' | 'utm_term' | 'utm_content']?: string;
};
